import { render } from "./SearchChat.vue?vue&type=template&id=b5c3a760&scoped=true"
import script from "./SearchChat.vue?vue&type=script&lang=js"
export * from "./SearchChat.vue?vue&type=script&lang=js"

import "./SearchChat.vue?vue&type=style&index=0&id=b5c3a760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c3a760"]])

export default __exports__